
import DatePicker from './date-picker'

export default DatePicker



// WEBPACK FOOTER //
// ./src/components/date-picker/index.js